<template>
  <div class="container">
    <div class="handle-wrapper">
      <Button
        type="primary"
        @click="$refs.EditFactoryDrawer.openDrawer()"
      >新增工厂</Button>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
    >
      <Table
        border
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      ></Table>
    </div>
    <EditFactoryDrawer
      ref="EditFactoryDrawer"
      :factoryList="tableData"
    />
  </div>
</template>

<script>
import EditFactoryDrawer from "./EditFactoryDrawer.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Factory",
  components: { EditFactoryDrawer },
  data() {
    return {
      value1: false,
      addNewDrawer: false,
      openedCustomer: null,
      tableHeight: 300,

      columns: [
        {
          title: "工厂名字",
          key: "name",
          width: 240,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditFactoryDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.name
              ),
            ]);
          },
        },
        {
          title: "本厂复配费",
          key: "PCE_ML_manufactCost",
          width: 110,
          align: "right",
          render: (h, params) => h("span", params.row.compound_manufactCost),
        },
        {
          title: "聚羧酸母液",
          key: "PCE_ML_manufactCost",
          width: 110,
          align: "right",
          render: (h, params) => h("span", params.row.PCE_ML_manufactCost),
        },
        {
          title: "萘系母液",
          key: "NAP_ML_manufactCost",
          width: 110,
          align: "right",
          render: (h, params) => h("span", params.row.NAP_ML_manufactCost),
        },
        {
          title: "减胶剂母液",
          key: "J_ML_manufactCost",
          width: 110,
          align: "right",
          render: (h, params) => h("span", params.row.J_ML_manufactCost),
        },
        {
          title: "速凝剂母液",
          key: "FSA_ML_manufactCost",
          width: 110,
          align: "right",
          render: (h, params) => h("span", params.row.FSA_ML_manufactCost),
        },
        {
          title: "地址",
          key: "address",
        },
        {
          title: "是否被禁用",
          key: "disabled",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#ed4014",
                },
              },
              params.row.disabled ? "是" : ""
            );
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.factory.factoryList,
    }),
  },
  methods: {
    ...mapActions({
      getFactorys: "factory/getFactorysAction",
    }),
  },
  created() {
    this.getFactorys({ show_detail: true, show_all: true });
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center

  .ivu-btn, .ivu-btn-primary
    margin-left auto

.table-wrapper
  width 100%
  height 100%
</style>
